// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2525": "40762d09","3135": "b2fe6823","6057": "f8b210dd",}[chunkId] + ".css"
}